import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { processClockings } from "./process";
import dayjsTZ from "../../../../../utils/dayjs";
import { NgjitjeIcon, ZbritjeIcon } from "../../../../../assets/icons";
import { HollowDotsSpinner } from "react-epic-spinners";
import { selectTodaysClockings } from "../../../selectors/todayClockings";

function ClockingsLogs() {
  const { clockings } = useSelector((state) => state.clockings);
  const { employees } = useSelector((state) => state.employeesList);
  const todaysClockings = useSelector(selectTodaysClockings);

  let usersList = useMemo(() => {
    if (!!clockings && !!employees) {
      return processClockings(clockings, employees, todaysClockings);
    }
    return null;
  }, [clockings, employees, todaysClockings]);

  return (
    <>
      {!!clockings && !!employees && !!usersList ? (
        <div
          className="wage-history-dashboard"
          style={{
            width: "100%",
            height: "100%",
            padding: 10,
            borderRadius: "0 0 10px 10px",
            overflowY: "scroll",
          }}
        >
          <div style={{ display: "flex", flexDirection: "column" }}>
            {usersList?.map((item, idx) => (
              <ListItem
                key={`${item?.clockingId || idx}-${item?.inOrOut}-${item?.time}`}
                user={`${
                  (item?.employeeInfo?.name || "") +
                  " " +
                  (item?.employeeInfo?.surname || "")
                }`}
                type={item?.inOrOut === "in" ? "Clock In" : "Clock Out"}
                time={dayjsTZ(item?.time).format("HH:mm")}
                color={item?.color || "gray"}
                item={item}
              />
            ))}
          </div>
        </div>
      ) : (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "100%",
          }}
        >
          <HollowDotsSpinner color="#1da193" size={24} />
        </div>
      )}
    </>
  );
}

export default ClockingsLogs;

const ListItem = ({ user, type, time, color, item }) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "8px 4px",
        borderBottom: "1px solid #f0f0f0",
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
        {item?.inOrOut === "in" ? (
          <NgjitjeIcon style={{ color }} />
        ) : (
          <ZbritjeIcon style={{ color }} />
        )}
        <span style={{ fontWeight: 500 }}>{user}</span>
        <span style={{ color: "#888", fontSize: 12 }}>{type}</span>
      </div>
      <span
        style={{
          background: color,
          color: color === "#E8E8E8" ? "#323338" : "#fff",
          padding: "2px 8px",
          borderRadius: 4,
          fontSize: 12,
        }}
      >
        {time}
      </span>
    </div>
  );
};
